import request from "@/utils/request";

// 查询收货地址信息
export function getAddressList(id) {
  return request({
    url: '/user/delivery-address/address/' + id,
    method: 'get',
  })
}
// 创建收货地址
export function addAddress(data) {
  return request({
    url: '/user/delivery-address/addAddress',
    method: 'post',
    data
  })
}
// 删除收货地址
export function delAddress(id) {
  return request({
    url: '/user/delivery-address/' + id,
    method: 'delete'
  })
}